import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  Modal,
} from "react-bootstrap";
import { FaPlus, FaTrash, FaEdit } from "react-icons/fa";
import "./DepartmentList.css";
import axios from "axios";

const DesignationList = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [show, setShow] = useState(false);
  const [designationName, setDesignationName] = useState("");
  const [search, setSearch] = useState("");
  const [designations, setDesignations] = useState([]);
  const [desigId, setDesigId] = useState(null);

  useEffect(() => {
    axios.post(`${API_BASE_URL}designation_list.php`)
      .then((response) => {
        if (response.data.head.code === 200) {
          setDesignations(response.data.body);
          // setFilteredOrders(response.data.body);
          // console.log(response.data.body[0]);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setDesignations([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setDesignations([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  const handleShow = () => {
    setDesignationName("");
    setDesigId(null);
    setShow(true);
  };

  const handleClose = () => {
    setDesignationName("");
    setDesigId(null);
    setShow(false);
  };

  const handleSave = () => {
    if (!designationName.trim()) return;

    if (desigId) {
      axios.post(`${API_BASE_URL}designation_detail_edit.php`,
        {
          desig_id: desigId,
          desig_name: designationName
        }
      )
        .then((response) => {
          if (response.data.head.code === 200) {
            window.location.reload();
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        }).finally(() => {
        });
    } else {
      axios.post(`${API_BASE_URL}designation_add.php`, { desig_name: designationName })
        .then((response) => {
          if (response.data.head.code === 200) {
            window.location.reload();
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        }).finally(() => {
        });
    }

    handleClose();
  };

  const handleEdit = (designation) => {
    setDesignationName(designation.desig_name);
    setDesigId(designation.desig_id);
    setShow(true);
  };

  // const handleDelete = (id) => {
  //   setDesignations(designations.filter((d) => d.desig_id !== id));
  // };
  const handleDelete = (desig_id) => {
    // setCustomers(customers.filter((c) => c.user_id !== user_id));
    axios.post(`${API_BASE_URL}designation_delete.php`, { desig_id: desig_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          window.location.reload();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  };

  // const toggleStatus = (id) => {
  //   setDesignations(
  //     designations.map((d) =>
  //       d.desig_id === id ? { ...d, isActive: !d.isActive } : d
  //     )
  //   );
  // };

  // simple live filter (case-insensitive partial match)
  const filteredDesignations = designations.filter((d) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      String(d.desig_id).toLowerCase().includes(q) ||
      (d.desig_name && d.desig_name.toLowerCase().includes(q))
    );
  });

  return (
    <>

      <Container fluid className="my-4 outer-container">
        <h2 className="text-center">Designation Management</h2>
        {filteredDesignations.length === 0 && (
          <Container fluid className="outer-container my-4">
            <Row>
              <Col>
                <div className="not-found-box">Loading...</div>
              </Col>
            </Row>
          </Container>
        )}
        <Row className="">
          <Col xs={12} md={6} lg={4} className="mb-2 mb-md-0">
            <Form.Control
              placeholder="Search Designation"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
          <Col xs={0} md={3} lg={4} className="d-none d-md-block"></Col>
          <Col xs={12} md={3} lg={4} className="d-flex justify-content-md-end">
            <div className="w-100 w-md-auto d-flex justify-content-md-end mt-3 mt-md-0">
              <Button className="btn-top" onClick={handleShow}>
                <FaPlus /> Add Designation
              </Button>
            </div>
          </Col>
        </Row>

        <Table responsive className="table-striped my-3 department-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              {/* <th>Status</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredDesignations.map((d, i) => (
              <tr key={d.desig_id}>
                <td>{i + 1}</td>
                <td>{d.desig_name}</td>
                {/* <td>
                  <Form.Check
                    type="switch"
                    id={`status-switch-${d.id}`}
                    checked={d.isActive}
                    onChange={() => toggleStatus(d.id)}
                  />
                </td> */}
                
                <td className="">
                  {d.desig_name!="HOD" && d.desig_name!="AO" && d.desig_name!="Principal" && d.desig_name!="Correspondent" && (
                    <>
                  <FaEdit
                    className="edit-icon me-3"
                    onClick={() => handleEdit(d)}
                  />
                  <FaTrash
                    className="delete-icon"
                    // onClick={() => handleDelete(d.desig_id)}
                    onClick={() => {
                          if (window.confirm("Are you sure you want to delete this?")) {
                            handleDelete(d.desig_id);
                          }
                        }}
                  />
                  </>
                  )}
                </td>
              </tr>
                      
            ))}

            {/* {filteredDesignations.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center">
                  No designations found
                </td>
              </tr>
            )} */}
          </tbody>
        </Table>
      </Container>

      {/* Modal for Add/Edit Designation */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{desigId ? "Edit Designation" : "Add Designation"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Designation Name</Form.Label>
              <Form.Control
                type="text"
                value={designationName}
                onChange={(e) => setDesignationName(e.target.value)}
              />
            </Form.Group>
            <Button className="btn-submit btn" onClick={handleSave}
            >
              {desigId ? "Update" : "Submit"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DesignationList;
